import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {BatchService} from '../../batchstamp/batch.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'modal-delete',
  templateUrl: './modalDelete.template.html',
  styleUrls: ['./modalDelete.component.css'],
  providers: [BatchService],
})
export class ModalDeleteComponent implements OnInit {
  item: any;
  btnClose: string;
  btnConfirm: string;
  cModalTitle: string;
  cModalContent: string;
  @Output() refreshListStamp = new EventEmitter<'refresh'>();
  @Output() idDelete = new EventEmitter<{ id: string | number }>();

  constructor(
    public bsModalRef: BsModalRef,
  ) {
  }

  ngOnInit() {
  }

  confirmDelete(id: number | string) {
    console.log('this.batch_detail', this.item)
    // @ts-ignore
    this.idDelete.emit(id);
  }

  onCloseModal() {
    this.bsModalRef.hide()
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/popup/confirmDelete/modalDelete.component.ts